const AccountForm = () => {
  return (
    <div className="rounded-21xl bg-light box-border w-[474px] flex flex-col py-16 px-8 items-center justify-start gap-[64px] text-center text-28xl text-dark font-footnote border-b-[4px] border-solid border-lavender md:self-stretch md:w-auto">
      <b className="relative tracking-[-0.02em] leading-[40px] [-webkit-text-stroke:1px_#000]">
        My account
      </b>
      <div className="self-stretch flex flex-col items-center justify-start gap-[16px] text-left text-base">
        <input
          className="self-stretch bg-light flex flex-row p-8 items-center justify-center border-[1px] border-dashed border-darkslategray-200"
          type="file"
        />
        <div className="self-stretch flex flex-col items-center justify-start gap-[8px]">
          <label
            className="cursor-pointer self-stretch relative font-bold"
            htmlFor="Label"
          >
            Name*
          </label>
          <input
            className="font-footnote text-base bg-gray-100 self-stretch rounded-21xl flex flex-row p-4 items-center justify-center border-[1px] border-solid border-darkslategray-200"
            type="text"
            placeholder="My Name"
            required
            id="Label"
          />
        </div>
        <div className="self-stretch flex flex-col items-center justify-start gap-[8px]">
          <label
            className="cursor-pointer self-stretch relative font-bold"
            htmlFor="FullName"
          >
            Email*
          </label>
          <input
            className="[border:none] font-footnote text-base bg-gray-100 self-stretch rounded-21xl flex flex-row p-4 items-center justify-center"
            type="email"
            placeholder="name@gmail.com"
            readOnly
          />
        </div>
      </div>
      <button
        className="[border:none] py-[22px] px-8 bg-gold self-stretch rounded-31xl flex flex-row items-center justify-center hover:bg-goldenrod-100"
        autoFocus
        disabled
      >
        <b className="relative text-5xl font-footnote text-dark text-left">
          Save
        </b>
      </button>
    </div>
  );
};

export default AccountForm;
